export default (state = {}, action) => {
    switch(action.type){
        case 'FETCH_METADATA':
            return action.payload;
        default: return state;
    }
}